import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/KeycloakProvider'

export function RoleBasedRedirect() {
    const { isLoading, isAdmin, isSupportEngineer } = useAuth()

    if (isLoading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner" />
                <p>Loading...</p>
            </div>
        )
    }

    if (isAdmin()) {
        return <Navigate to="/admin" replace />
    }

    if (isSupportEngineer()) {
        return <Navigate to="/dashboard" replace />
    }

    return <Navigate to="/no-access" replace />
}
